module.exports = __webpack_public_path__ + "static/media/sustainability1.ae9d384e.png";